import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LoadingSpinner } from "@/components/ui/loading-spinner";

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const { user, ready, loading } = useAuth();
  const id = useRef(crypto.randomUUID());
  
  useEffect(() => { 
    console.log('[MOUNT] ProtectedRoute', id.current); 
  }, []);
  
  useEffect(() => () => console.log('[UNMOUNT] ProtectedRoute', id.current), []);

  useEffect(() => {
    if (!ready || loading) return; // Wait for auth to be ready
    
    if (!user) {
      console.log("[ProtectedRoute] No user, redirecting to coming soon");
      navigate("/coming-soon", { replace: true });
    }
  }, [ready, loading, user, navigate]);

  if (!ready || loading) return <LoadingSpinner />; // Only show spinner during initial load
  if (!user) return <LoadingSpinner />; // Brief spinner while redirecting
  
  return <>{children}</>;
}
